/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralDocumentInput
 */
export interface ReferralDocumentInput {
    /**
     * 
     */
    document_id: number;
    /**
     * 
     */
    document_type?: string;
    /**
     * 
     */
    file_name: string;
    /**
     * 
     */
    s3_key: string;
    /**
     * 
     */
    content_type: string;
    /**
     * 
     */
    file_size_bytes: number;
    /**
     * 
     */
    page_count?: number;
    /**
     * 
     */
    original_document_hash?: string;
}

/**
 * Check if a given object implements the ReferralDocumentInput interface.
 */
export function instanceOfReferralDocumentInput(value: object): value is ReferralDocumentInput {
    if (!('document_id' in value) || value['document_id'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    if (!('s3_key' in value) || value['s3_key'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    if (!('file_size_bytes' in value) || value['file_size_bytes'] === undefined) return false;
    return true;
}

export function ReferralDocumentInputFromJSON(json: any): ReferralDocumentInput {
    return ReferralDocumentInputFromJSONTyped(json, false);
}

export function ReferralDocumentInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralDocumentInput {
    if (json == null) {
        return json;
    }
    return {
        
        'document_id': json['document_id'],
        'document_type': json['document_type'] == null ? undefined : json['document_type'],
        'file_name': json['file_name'],
        's3_key': json['s3_key'],
        'content_type': json['content_type'],
        'file_size_bytes': json['file_size_bytes'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        'original_document_hash': json['original_document_hash'] == null ? undefined : json['original_document_hash'],
    };
}

export function ReferralDocumentInputToJSON(json: any): ReferralDocumentInput {
    return ReferralDocumentInputToJSONTyped(json, false);
}

export function ReferralDocumentInputToJSONTyped(value?: ReferralDocumentInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_id': value['document_id'],
        'document_type': value['document_type'],
        'file_name': value['file_name'],
        's3_key': value['s3_key'],
        'content_type': value['content_type'],
        'file_size_bytes': value['file_size_bytes'],
        'page_count': value['page_count'],
        'original_document_hash': value['original_document_hash'],
    };
}

